import { AppDispatch } from '../../data/store';
import * as providerSlice from '../../data/provider.slice';

interface IInternalNoteDetail {
  // tripLegInternalNoteID: string;
}

enum InternalNoteEventType {}
// TripLegInternalNoteCreated = 'TripLegInternalNoteCreated', // TODO: placeholder, not implemented

/**
 * Method for handling all Internal Note Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateInternalNote(
  dispatch: AppDispatch,
  detailType: string,
  detail: IInternalNoteDetail,
) {
  // switch (detailType) {}
}

export { InternalNoteEventType, updateInternalNote };
